/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ReportsPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 25rem;
  padding: 2rem;
  width: 100%;
  font-weight: bold;
  font-family: 'MontserratSemiBold';
`;
